/**
 * Warning time for notifying developers that a stream is hanging in dev mode
 * using a console.warn.
 */
export const HANGING_STREAM_WARNING_TIME_MS = 15 * 1000;
